
import { toast } from 'sonner';

interface UseOfferDeletionProps {
  onDelete?: (offerId: string) => void;
  onClose: () => void;
}

export const useOfferDeletion = ({ onDelete, onClose }: UseOfferDeletionProps) => {
  const handleDeleteOffer = async (offerId: string) => {
    if (onDelete) {
      try {
        await onDelete(offerId);
        return true;
      } catch (error) {
        console.error("DEBUG - useOfferDeletion - Error in handleDeleteOffer:", error);
        throw error;
      }
    } else {
      console.error("DEBUG - useOfferDeletion - No onDelete function provided");
      return false;
    }
  };

  return {
    handleDeleteOffer
  };
};
